import React from "react";
import { reportError } from "../services/CrashReporting";

// Errores de render de React: sin esto la app queda en blanco y el error no
// llega a window.onerror, así que tampoco aparecería en el panel admin.
class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    reportError(error, {
      fatal: true,
      context: { type: "react", componentStack: (info?.componentStack || "").slice(0, 4000) },
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div style={{ padding: 24, textAlign: "center" }}>
            <p>Ocurrió un error inesperado.</p>
            <button type="button" onClick={() => window.location.reload()}>
              Recargar
            </button>
          </div>
        )
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
